import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const CREATE_PAYMENT = gql`
  mutation createPaymentEntity($doc: PaymentInput!) {
    createPaymentEntity(doc: $doc) {
      id
      status
      method
      reference
      amount
    }
  }
`;

export const UPDATE_PAYMENT = gql`
  mutation createPaymentEntity($updatedDoc: PaymentInput!, $filter: PaymentInput!) {
    updatePaymentEntity(updatedDoc: $updatedDoc, filter: $filter) {
      id
      status
      method
      reference
      amount
    }
  }
`;

export const DELETE_PAYMENT = gql`
  mutation createPaymentEntity($id: String!) {
    deletePaymentEntity(id: $id) {
      message
    }
  }
`;
